module.exports = "/images/gotham-7.jpg";